module.exports = __webpack_public_path__ + "img/e02142a8fad3b3d7ed23a69499f870d3.png";